<template>
  <section class="not-found">
    <header>
      <h1>
        <slot>Nothing here :( </slot>
      </h1>
    </header>
    <div>
      <router-link to="/">Home</router-link>
    </div>
  </section>
</template>
<script>
export default {
  meta: {
    title: 'Not Found'
  }
};
</script>
<style lang="scss" scoped>
.not-found {
  width: 100%;
  text-align: center;
  font-weight: 700;

  header {
    width: 100%;
    padding: 1rem 2rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid var(--theme-highlight);
    box-sizing: border-box;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 700;
  }
}
</style>
